// src/components/ui/2-organisms/StorefrontProfileHeader/StorefrontProfileHeader.js

import React from 'react';
import Icon from '../../1-molecules/Icon/Icon';
import styles from './StorefrontProfileHeader.module.css';
import { getOptimizedImageUrl } from '../../../../utils/imageUtils';

const StorefrontProfileHeader = ({ jeweller }) => {
  // Combine firstName and surname for the full name
  const jewellerFullName = [jeweller?.firstName, jeweller?.surname]
    .filter(Boolean)
    .join(' ') || 'Jeweller';

  // Profile photo URL with fallback
  const profilePhotoUrl = jeweller?.profilePhoto || 
    'https://placehold.co/80x80/ccc/999?text=JD';

  // Use town field for location
  const location = jeweller?.location || jeweller?.town || 'Location';
  
  // Get header image from jeweller's headerImage field with fallback
  const headerImageUrl = jeweller?.headerImage || 
    'https://placehold.co/448x128/eee/ccc?text=Header';

  return (
    <header className={styles.header}>
      {/* CHANGED: Single full-width header banner */}
      <div className={styles.headerBanner}>
        <img 
          src={getOptimizedImageUrl(headerImageUrl, 'HEADER')} 
          alt={`${jeweller?.companyName || 'Jeweller'} header`}
          className={styles.headerImage}
        />
      </div>

      <div className={styles.profileInfo}>
        <div className={styles.profilePhotoWrapper}>
          <img 
            src={profilePhotoUrl} 
            alt={jewellerFullName} 
            className={styles.profilePhoto} 
          />
        </div>
        <div className={styles.profileText}>
          <h1 className={styles.companyName}>{jeweller?.companyName}</h1>
          <div className={styles.location}>
            <Icon name="location" size="s" />
            <span>{location}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default StorefrontProfileHeader;
